<!-- MODAL asignarCliente -->
<div mdbModal #asignarCliente="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Asignación de cliente
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <form [formGroup]='formData' (ngSubmit)="buscar(true)" novalidate>
        <div class="modal-body" *ngIf="mode === 'SEARCH'">

          <!-- <div class="row">
            <div class="col">
              <strong>Buscar por: </strong>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorNombre" formControlName="buscarPor"
                  [value]="TIPO_NOMBRE" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorNombre">Nombre</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idRadioBuscarPorRut" formControlName="buscarPor"
                  [value]="TIPO_RUT" (change)='cleanInput()' mdbInput />
                <label class="form-check-label" [for]="idRadioBuscarPorRut">Rut</label>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col-md-3">
              <div class="md-form">
                <input value="" type="text" id="nombreProduct" class="form-control" placeholder="Nombre del cliente"
                  #nombreProduct formControlName="nombre" />
                <label for="nombreProduct">Nombre del cliente</label>
                <!-- <div *ngIf="
                    formData.get('nombre').invalid &&
                    (formData.get('nombre').dirty ||
                    formData.get('nombre').touched)
                  ">
                  <mdb-error *ngIf="formData.get('nombre').hasError('required')">
                    Ingrese nombre
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="col-md-3">
              <div class="md-form">
                <input value="" type="text" id="nombreProduct" class="form-control" placeholder="RUT del cliente"
                  #nombreProduct formControlName="rut" formatRut />
                <label for="nombreProduct">RUT del cliente</label>
                <!-- <div *ngIf="
                    formData.get('rut').invalid &&
                    (formData.get('rut').dirty ||
                    formData.get('rut').touched)
                  ">
                  <mdb-error *ngIf="formData.get('rut').hasError('required')">
                    Ingrese rut
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="" style="width: 50px;">
              <button mdbBtn type="submit" class="btn-cuadrado" color="secondary" mdbWavesEffect>
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
            </div>
            <div class="col-md-4" style="display: flex; align-items: center;">
              <mdb-checkbox formControlName="eliminar_vendedor" (change)="OnchangeDeleteVendedor($event)">Eliminar Vendedor</mdb-checkbox>
          </div>
          </div>

          <!-- <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div> -->
          <mdb-spinner spinnerColor="blue" *ngIf="loading"  style="padding-left:45%;"></mdb-spinner>

          <table class="table table-striped table-hover table-sm align-middle" *ngIf="data && busquedaIniciada">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center">
                  <ng-container>
                    <mdb-checkbox (change)='checkAllChange($event)' [disabled]="!data || data.length === 0">
                      <span>
                        RUT
                      </span>
                    </mdb-checkbox>
                  </ng-container>

                </th>
                <th scope="col" class="text-center">Nombre</th>
                <th scope="col" class="text-center">Rut Sucursal</th>
                <th scope="col" class="text-center"> Dirección
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && data?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let cliente of data">
                <td>
                  <mdb-checkbox [checked]="cliente.checked" (change)='checkCliente(cliente, $event)' >
                    <span>
                      {{ cliente.rutFormato | rut }}
                    </span>
                  </mdb-checkbox>
                </td>
                <td>{{ cliente.razon_social }}</td>
                <td>{{ this.rutService.AgregarDV(cliente.empresa_rut) | rut }}</td>

                <td>{{ cliente.direccion_completa }}</td>
                <!-- <td *ngIf="!multiple">
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="selectData(cliente)">
                    Seleccionar
                  </button>
                </td> -->
              </tr>
            </tbody>
            <ng-container *ngIf="data.length > 0">
              <app-pagination *ngIf="!config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChange($event)"></app-pagination>
              <app-pagination *ngIf="config.paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChangeLocal($event)"></app-pagination>
            </ng-container>
          </table>
        </div>

        <div class="modal-body" *ngIf="mode === 'VIEW_SELECTED'">
          <h5 *ngIf="dataSeleccionadaAll?.length === 1">
            ({{dataSeleccionadaAll?.length | json}}) Seleccionado
          </h5>
          <h5 *ngIf="dataSeleccionadaAll?.length > 1">
            ({{dataSeleccionadaAll?.length | json}}) Seleccionados
          </h5>

          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">RUT</th>
                <th scope="col">Nombre</th>
                <th scope="col" class="text-center" *ngIf="!onlyRut">Sucursal</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cliente of dataSeleccionada">
                <td>{{ cliente.rutFormato | rut }}</td>
                <td *ngIf="queryType === 'RUT_SUCURSAL'">{{ cliente.razon_social }}</td>
                <td *ngIf="queryType !== 'RUT_SUCURSAL'">{{ cliente.nombre }}</td>
                <td *ngIf="!onlyRut">{{ cliente.direccion_completa }}</td>
                <td>
                  <ng-container *ngIf="config.allowUncheckSelected">
                    <button mdbBtn type="button" size="sm" color="danger" mdbWavesEffect class="btn-actions-sm"
                      (click)="checkCliente(cliente, $event)">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </ng-container>
                  <!-- <mdb-checkbox [checked]="cliente.checked" (change)='checkCliente(cliente)' *ngIf="multiple">
                    <span>
                      {{ cliente.rutFormato | rut }}
                    </span>
                  </mdb-checkbox> -->
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChangeLocalSelected($event)">
            </app-pagination>
          </table>
        </div>
      </form>

      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" [disabled]="ClientesSeleccion.length === 0" class="btn btn-secondary waves-light" mdbWavesEffect (click)="asignarClienteTraspaso()">
          Asignar
        </button>
      </div>
    </div>
  </div>
</div>
